/* Sacola da versão curva (desenho do protótipo, carrinho real da Shopify).
   Dados: snippets/plenty-sacola-data (JSON). Atualiza com /cart/change.js e /cart/update.js pedindo a seção
   plenty-sacola junto, e se redesenha. Avisa o resto do tema com o evento cart:update (bolinha da sacola). */
(function () {
  'use strict';
  if (window.__plentySacola) return;
  window.__plentySacola = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION = 'plenty-sacola';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  var I = {
    x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    minus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12h12"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>',
    trash: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V5h6v2M6.5 7l1 13h9l1-13"/></svg>',
    ok: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    tag: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><path d="M7.5 7.5h.01"/></svg>',
    ticket: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2M13 17v2M13 11v2"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>',
    shield: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>',
    ret: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>',
    chev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'
  };
  var MES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

  function brl(c) {
    var v = (Math.round(c) / 100).toFixed(2).split('.');
    return 'R$ ' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  /* ---------- kits (tabela em plenty-config) ---------- */
  function kitOf(D, lines) {
    var by = {}, sub = {};
    lines.forEach(function (x) {
      (x.kits || []).forEach(function (c) {
        by[c] = (by[c] || 0) + x.q;
        sub[c] = (sub[c] || 0) + x.unit * x.q;
      });
    });
    var best = null;
    D.kits.forEach(function (k) {
      var n = by[k.c] || 0, tier = null;
      k.t.forEach(function (t) { if (n >= t[0]) tier = t; });
      if (!tier) return;
      var amt = tier[1] === 'pct' ? Math.floor(sub[k.c] * tier[2]) / 100 : tier[2];
      if (!best || amt > best.amt) best = { c: k.c, amt: amt, label: tier[3] };
    });
    return best;
  }
  function kitLines(D) {
    return D.items.map(function (it) { return { kits: it.kits, q: it.q, unit: it.orig / it.q, pid: it.pid }; });
  }
  /* fileira "Combina com a sua sacola": primeiro a peça que abre ou sobe um kit (maior desconto; empate = a mais barata),
     depois as recomendações da Shopify (as mesmas do "Complete o look" antigo). Cada peça leva o desconto de kit que daria. */
  function railOf(D) {
    var lines = kitLines(D), cur = kitOf(D, lines), curAmt = cur ? cur.amt : 0, noKit = !!codeApplied(D);
    var inCart = {}, seen = {}, out = [];
    D.items.forEach(function (it) { inCart[it.pid] = 1; });
    function gain(c) {
      if (noKit || !c.c) return 0;
      var nk = kitOf(D, lines.concat([{ kits: [c.c], q: 1, unit: c.p }]));
      var g = nk ? nk.amt - curAmt : 0;
      return g > 1 ? g : 0;
    }
    var best = null;
    if (!noKit) {
      D.cands.forEach(function (c) {
        if (inCart[c.pid] || !c.v.some(function (v) { return v.a; })) return;
        var g = gain(c);
        if (g && (!best || g > best.g + 1 || (Math.abs(g - best.g) <= 1 && c.p < best.c.p))) best = { c: c, g: g };
      });
    }
    if (best) { out.push(best); seen[best.c.pid] = 1; seen['b:' + best.c.base] = 1; }
    (R.list || []).forEach(function (c) {
      if (out.length >= 8 || inCart[c.pid] || seen[c.pid] || seen['b:' + c.base] || !c.v.some(function (v) { return v.a; })) return;
      seen[c.pid] = 1;
      seen['b:' + c.base] = 1;
      out.push({ c: c, g: gain(c) });
    });
    return out;
  }
  function poolOf(D) {
    var m = {};
    D.cands.concat(R.list || []).forEach(function (c) { if (!m[c.pid]) m[c.pid] = c; });
    return m;
  }

  /* recomendações da Shopify (intent related) para a peça mais recente da sacola */
  var R = { pid: null, list: [], busy: false };
  function loadRecos() {
    if (!D || !D.items.length) return;
    var pid = D.items[0].pid;
    if (R.pid === pid || R.busy) return;
    R.busy = true;
    fetch(root + 'recommendations/products?section_id=plenty-sacola-recos&product_id=' + pid + '&intent=related&limit=10')
      .then(function (r) { return r.text(); })
      .then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var sc = doc.querySelector('[data-ps-recos]');
        R.list = sc ? JSON.parse(sc.textContent) : [];
        R.pid = pid;
        R.busy = false;
        draw();
      })
      .catch(function () { R.busy = false; });
  }

  /* ---------- estado da interface (sobrevive aos redesenhos) ---------- */
  var S = { open: false, input: '', err: '', fr: {}, pk: null, pkFx: false, ofrFx: false, ofrFxI: -1, seen: null, railIdx: 0 };
  var D = null, box = null, busy = false, queue = [];

  function label(D, it) {
    var a = it.alloc[0];
    if (!a) return it.full > it.fin ? '<span class="ps-bdg ps-pc">−' + Math.round((1 - it.fin / it.full) * 100) + '%</span>' : '';
    if (a.type === 'discount_code') return '<span class="ps-bdg">' + I.ticket + '<span class="ps-cd">' + esc(a.t) + '</span></span>';
    var k = kitOf(D, kitLines(D));
    if (k && it.kits.indexOf(k.c) > -1) return '<span class="ps-bdg">' + I.tag + esc(k.label) + '</span>';
    return '<span class="ps-bdg">' + I.tag + esc(shortTitle(a.t)) + '</span>';
  }
  function shortTitle(t) { return String(t).split(' — ')[0].split(' por ')[0]; }
  function codeApplied(D) {
    for (var i = 0; i < D.apps.length; i++) if (D.apps[i].type === 'discount_code' && D.apps[i].v > 0) return D.apps[i];
    return null;
  }

  function draw() {
    if (!box || !D) return;
    var n = D.count, top = '<div class="ps-top"><b>Sacola' + (n ? '<span>(' + n + ')</span>' : '') + '</b><button type="button" class="ps-x" data-a="close">' + I.x + 'Fechar</button></div>';
    var root$ = box.closest('.psc') || box;
    root$.classList.toggle('psc--empty', !n);
    if (!n) {
      var E = D.empty, minis = (E.minis || []).map(function (m) {
        return '<a class="ps-mini" href="' + esc(m.url) + '"><figure>' + (m.img ? '<img src="' + esc(m.img) + '" alt="" width="360" height="540" loading="lazy">' : '') + '</figure><span>' + esc(m.nm) + '</span><span class="ps-price">' + brl(m.p) + '</span></a>';
      }).join('');
      box.innerHTML = top + '<div class="ps-empty"><h2>Sua sacola está vazia.</h2><p>Comece pelo drop novo.</p><div class="ps-acts"><a class="ps-btn" href="' + esc(E.ctaUrl) + '">' + esc(E.cta) + '</a></div>' + (minis ? '<div class="ps-sug"><span class="ps-rot">Mais vendidos</span><div class="ps-rail">' + minis + '</div></div>' : '') + '</div>';
      S.seen = {};
      return;
    }
    var tot = D.total, free = D.free > 0 && tot >= D.free, left = D.free - tot, pct = D.free > 0 ? Math.min(100, tot / D.free * 100) : 100;
    var ship = !D.free ? '' : (left > 0
      ? '<div class="ps-ship" style="--p:' + pct.toFixed(1) + '%"><p>Faltam <b class="ps-price">' + brl(left) + '</b> para o frete grátis</p><div class="ps-trk"><div class="ps-fill"></div></div></div>'
      : '<div class="ps-ship ps-ok" style="--p:100%"><p>' + I.ok + 'Frete grátis liberado</p><div class="ps-trk"><div class="ps-fill"></div></div></div>');

    var seen = S.seen, now = {};
    var li = D.items.map(function (it, idx) {
      now[it.key] = 1;
      var isNew = seen && !seen[it.key];
      var mq = '<span class="ps-mq">' + (it.q > 1
        ? '<button type="button" data-a="dec" data-i="' + idx + '" aria-label="Diminuir">' + I.minus + '</button>'
        : '<button type="button" data-a="dec" data-i="' + idx + '" aria-label="Remover" class="ps-trash">' + I.trash + '</button>') +
        '<span class="ps-qn">' + it.q + '</span><button type="button" data-a="inc" data-i="' + idx + '" aria-label="Aumentar">' + I.plus + '</button></span>';
      var on = it.fin < it.full;
      var vr = [it.color, it.size].filter(Boolean).join(' · ');
      return '<li class="ps-it' + (isNew ? ' ps-fxin' : '') + '" data-key="' + esc(it.key) + '"><div class="ps-row"><a class="ps-fig" href="' + esc(it.url) + '"><figure>' + (it.img ? '<img src="' + esc(it.img) + '" alt="" width="240" height="320">' : '') + '</figure></a>' +
        '<div class="ps-t"><a class="ps-nm" href="' + esc(it.url) + '">' + esc(it.nm) + '</a>' + (vr ? '<span class="ps-vr">' + esc(vr) + '</span>' : '') + label(D, it) + '</div>' +
        '<div class="ps-rt">' + (on ? '<span class="ps-pr ps-price ps-dsc">' + brl(it.fin) + '</span><span class="ps-was">' + brl(it.full) + '</span>' : '<span class="ps-pr ps-price">' + brl(it.fin) + '</span>') + mq + '</div></div></li>';
    }).join('');
    S.seen = now;

    var code = codeApplied(D), sg = '';
    var rail = railOf(D);
    if (S.pk && !rail[S.pk.i]) S.pk = null;
    if (S.railIdx >= rail.length) S.railIdx = 0;
    if (rail.length) {
      var pool = poolOf(D);
      var cards = rail.map(function (o, i) {
        var c = o.c, off = o.g ? Math.round(o.g / c.p * 100) : 0;
        var pk = S.pk && S.pk.i === i ? (pool[S.pk.pid] || c) : null;
        if (pk) {
          var sibs = [];
          Object.keys(pool).forEach(function (k) { var x = pool[k]; if (x.base === c.base && x.v.some(function (v) { return v.a; })) sibs.push(x); });
          var sizes = pk.v.map(function (v) { return '<button type="button" data-a="psz" data-id="' + v.id + '"' + (v.a ? '' : ' disabled') + '>' + esc(v.t) + '</button>'; }).join('');
          return '<div class="ps-ofr-c ps-pick' + (S.pkFx ? ' ps-fx' : '') + '" data-off="' + off + '"><figure>' + (pk.img ? '<img src="' + esc(pk.img) + '" alt="" width="240" height="300">' : '') + '</figure><div class="ps-ofr-pk">' +
            (sibs.length > 1 ? '<div class="ps-ofr-sw">' + sibs.map(function (x) { return '<button type="button" data-a="pcol" data-pid="' + x.pid + '" aria-label="' + esc(x.color) + '"' + (x.pid === pk.pid ? ' class="is-on" aria-pressed="true"' : ' aria-pressed="false"') + ' style="background:' + esc(x.hex) + '"></button>'; }).join('') + '<small>' + esc(pk.color) + '</small></div>' : '<small>Qual tamanho?</small>') +
            '<div class="ps-ofr-sz">' + sizes + '<button type="button" data-a="pcx" class="ps-ofr-x" aria-label="Cancelar">&#x2715;</button></div></div></div>';
        }
        var price = o.g ? '<em class="ps-price">' + brl(c.p - o.g) + '</em><s class="ps-price">' + brl(c.p) + '</s>' : '<span class="ps-price">' + brl(c.p) + '</span>';
        return '<div class="ps-ofr-c' + (S.ofrFx && S.ofrFxI === i ? ' ps-fx' : '') + '" data-off="' + off + '"><a class="ps-ofr-fig" href="' + esc(c.url) + '" tabindex="-1"><figure>' + (c.img ? '<img src="' + esc(c.img) + '" alt="" width="240" height="300" loading="lazy">' : '') + '</figure></a><div class="ps-ofr-t"><b>' + esc(c.nm) + (c.color ? '<span class="ps-vr"> · ' + esc(c.color) + '</span>' : '') + '</b><small>' + price + '</small></div><button type="button" class="ps-ofr-add" data-a="pick" data-i="' + i + '" data-pid="' + c.pid + '" aria-label="Adicionar ' + esc(c.nm + ' ' + c.color) + '">Adicionar</button></div>';
      }).join('');
      var off0 = rail[S.railIdx || 0].g ? Math.round(rail[S.railIdx || 0].g / rail[S.railIdx || 0].c.p * 100) : 0;
      sg = '<div class="ps-ofr' + (rail.length > 1 ? ' ps-many' : '') + '"><span class="ps-rot ps-ofr-l">Combina com a sua sacola<span class="ps-off" data-ps-off>' + (off0 ? '· <b>' + off0 + '% OFF</b>' : '') + '</span></span><div class="ps-rail" data-ps-rail>' + cards + '</div></div>';
    }
    S.pkFx = false;
    S.ofrFx = false;

    var fr = S.fr, fv = free ? 0 : (fr.v || 0);
    var parc = brl((tot + fv) / (D.parc || 1)), pixT = Math.round(tot * (1 - D.pix / 100)) + fv;
    var chip = fr.cep && fr.res && !fr.open
      ? '<div class="ps-chip ps-res">' + I.truck + '<span>' + fr.res + ' · ' + (free || fr.v === 0 ? '<span class="ps-frok">Grátis</span>' : '<span class="ps-price">' + brl(fr.v) + '</span>') + '</span><button type="button" class="ps-lk" data-a="frop">Alterar</button></div>'
      : fr.open
        ? '<div class="ps-chip ps-cepo">' + I.truck + '<input class="ps-cepin" data-cep id="ps-cep" value="' + esc(fr.cep || '') + '" placeholder="00000-000" aria-label="Seu CEP" inputmode="numeric" autocomplete="postal-code" maxlength="9"><button type="button" class="ps-lk" data-a="frc">' + (fr.busy ? 'Calculando' : 'Calcular') + '</button></div>' + (fr.err ? '<p class="ps-err">' + esc(fr.err) + '</p>' : '')
        : '<div class="ps-chip">' + I.truck + '<button type="button" class="ps-lk" data-a="frop">Calcular frete</button></div>';
    var cupRow = code ? '' : (S.open
      ? '<div class="ps-fld"><input data-cp id="ps-cupom" value="' + esc(S.input) + '" placeholder="Código do cupom" aria-label="Código do cupom" autocapitalize="characters"><button type="button" data-a="cpap">' + (S.cpBusy ? 'Aplicando' : 'Aplicar') + '</button></div>' + (S.err ? '<p class="ps-err">' + esc(S.err) + '</p>' : '')
      : '<button type="button" class="ps-q" data-a="cpop" aria-expanded="false"><span>Tem um cupom?</span>' + I.chev + '</button>');
    var discRows = D.apps.filter(function (a) { return a.v > 0; }).map(function (a) {
      if (a.type === 'discount_code') return '<div class="ps-ln ps-disc"><span class="ps-lb"><span class="ps-bdg">' + I.ticket + '<span class="ps-cd">' + esc(a.t) + '</span></span><button type="button" class="ps-rmv" data-a="cprm">Remover</button></span><span class="ps-price">− ' + brl(a.v) + '</span></div>';
      var k = kitOf(D, kitLines(D));
      return '<div class="ps-ln ps-disc"><span class="ps-lb"><span class="ps-bdg">' + I.tag + esc(/^kit /i.test(a.t) && k ? k.label : shortTitle(a.t)) + '</span></span><span class="ps-price">− ' + brl(a.v) + '</span></div>';
    }).join('');
    var frRow = free ? '<div class="ps-ln"><span>Frete</span><span class="ps-frok">Grátis</span></div>' : (fr.v && !fr.open ? '<div class="ps-ln"><span>Frete</span><span class="ps-price">+ ' + brl(fr.v) + '</span></div>' : '');

    box.innerHTML = top + ship +
      '<div class="ps-body"><ul class="ps-items">' + li + '</ul>' + sg + '</div>' +
      '<div class="ps-foot">' + chip + cupRow + discRows + frRow +
      '<div class="ps-pay"><div class="ps-pix"><span class="ps-pl">Total no Pix</span><span class="ps-price">' + brl(pixT) + '</span></div>' +
      '<div class="ps-ln"><span>ou no cartão</span><span class="ps-card">Até ' + D.parc + 'x de <span class="ps-price">' + parc + '</span> sem juros</span></div></div>' +
      '<a class="ps-btn" href="' + esc(D.checkout) + '">Concluir compra</a>' +
      '<div class="ps-trust"><span>' + I.shield + 'Compra segura</span><span>' + I.ret + 'Troca em 30 dias</span></div></div>';
    railSetup();
    loadRecos();
  }

  /* ---------- fileira que passa sozinha (como o "Complete o look" antigo: a cada 3,5 s, volta ao começo no fim).
     Para com o mouse em cima, no toque (por 6 s), enquanto a pessoa escolhe cor/tamanho e com "reduzir movimento". ---------- */
  var T = { hold: 0, hover: false, sc: 0 };
  function railEl() { return box && box.querySelector('[data-ps-rail]'); }
  function railStep(r) { var c = r.firstElementChild; return c ? c.getBoundingClientRect().width + 6 : 0; }
  function railSetup() {
    var r = railEl();
    T.hover = false;
    if (!r) return;
    r.scrollLeft = (S.railIdx || 0) * railStep(r);
    r.addEventListener('scroll', function () {
      clearTimeout(T.sc);
      T.sc = setTimeout(function () {
        var st = railStep(r);
        if (!st) return;
        var i = Math.round(r.scrollLeft / st);
        if (i !== S.railIdx) { S.railIdx = i; railOff(r, i); }
      }, 90);
    }, { passive: true });
    r.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') T.hover = true; });
    r.addEventListener('pointerleave', function () { T.hover = false; });
    r.addEventListener('touchstart', function () { T.hold = Date.now() + 6000; }, { passive: true });
    r.addEventListener('touchend', function () { T.hold = Date.now() + 6000; }, { passive: true });
  }
  function railOff(r, i) {
    var c = r.children[i], el = box.querySelector('[data-ps-off]');
    if (!c || !el) return;
    var off = +c.dataset.off, html = off ? '· <b>' + off + '% OFF</b>' : '';
    if (el.innerHTML === html) return;
    el.innerHTML = html;
    el.classList.remove('ps-swap');
    void el.offsetWidth;
    el.classList.add('ps-swap');
  }
  function railTick() {
    var r = railEl();
    if (!r || r.children.length < 2) return;
    var dlg = box.closest('dialog');
    if (dlg && !dlg.open) return;
    if (S.pk || T.hover || Date.now() < T.hold || reduce.matches || document.hidden) return;
    if (r.contains(document.activeElement)) return;
    var i = ((S.railIdx || 0) + 1) % r.children.length;
    S.railIdx = i;
    r.scrollTo({ left: i * railStep(r), behavior: 'smooth' });
    railOff(r, i);
  }

  /* ---------- servidor ---------- */
  function readData(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var s = doc.querySelector('[data-ps-data]');
    return s ? JSON.parse(s.textContent) : null;
  }
  function announce(count) {
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = { resource: { item_count: count }, sourceId: 'psc', data: { itemCount: count, source: 'psc', sections: {} } };
    document.dispatchEvent(ev);
  }
  function post(url, body) {
    body.sections = SECTION;
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }
  function apply(j) {
    var html = j && j.sections && j.sections[SECTION];
    var nd = html ? readData(html) : null;
    if (nd) {
      D = nd;
      draw();
      announce(D.count);
    }
    return j;
  }
  function run(task) {
    queue.push(task);
    if (busy) return;
    (function next() {
      var t = queue.shift();
      if (!t) { busy = false; if (box) box.classList.remove('is-busy'); return; }
      busy = true;
      if (box) box.classList.add('is-busy');
      t().catch(function () {}).then(next);
    })();
  }
  function refresh() {
    run(function () {
      return fetch(root + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var nd = j && j[SECTION] ? readData(j[SECTION]) : null;
          if (nd) { D = nd; draw(); }
        });
    });
  }
  function change(key, q) {
    run(function () { return post('cart/change.js', { id: key, quantity: q }).then(apply); });
  }
  function addVariant(id) {
    run(function () {
      return post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }).then(function () {
        return fetch(root + '?sections=' + SECTION).then(function (r) { return r.json(); }).then(function (j) {
          var nd = j && j[SECTION] ? readData(j[SECTION]) : null;
          if (nd) { D = nd; draw(); announce(D.count); }
        });
      });
    });
  }
  function codesNow() {
    return D.apps.filter(function (a) { return a.type === 'discount_code'; }).map(function (a) { return a.t; });
  }
  function applyCode(v) {
    S.cpBusy = true;
    draw();
    run(function () {
      var prev = codesNow();
      return post('cart/update.js', { discount: prev.concat([v]).join(',') }).then(function (j) {
        var bad = (j.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === v.toUpperCase() && !d.applicable; })[0];
        S.cpBusy = false;
        if (bad) {
          var hasKit = !!kitOf(D, kitLines(D));
          S.err = hasKit ? 'Este cupom não vale junto com o desconto do kit.' : 'Cupom não encontrado.';
          S.open = true;
          S.input = v;
          return post('cart/update.js', { discount: prev.join(',') }).then(apply);
        }
        S.open = false;
        S.err = '';
        S.input = '';
        return apply(j);
      }).catch(function () {
        S.cpBusy = false;
        S.err = 'Não deu para aplicar agora. Tente de novo.';
        draw();
      });
    });
  }
  function removeCode() {
    run(function () { return post('cart/update.js', { discount: '' }).then(apply); });
  }

  /* estado pela faixa do CEP (a consulta de frete da Shopify pede o estado) */
  var UF = [[1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'], [40000, 48999, 'BA'], [49000, 49999, 'SE'],
    [50000, 56999, 'PE'], [57000, 57999, 'AL'], [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'], [69300, 69399, 'RR'], [69400, 69899, 'AM'],
    [69900, 69999, 'AC'], [70000, 72799, 'DF'], [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'], [88000, 89999, 'SC'], [90000, 99999, 'RS']];
  function ufOf(n) {
    for (var i = 0; i < UF.length; i++) if (n >= UF[i][0] && n <= UF[i][1]) return UF[i][2];
    return '';
  }

  /* frete: consulta de frete da própria Shopify (tarifas cadastradas na loja) */
  /* ---------- frete pelo Frenet, pelo carrinho (fonte única: sacola e página de produto) ----------
     PlentyFrete.cotar(cep) → frete da sacola atual.
     PlentyFrete.cotar(cep, variante) → sacola atual + esta peça: a peça entra na sacola só durante o cálculo
     e sai em seguida (a mesma técnica dos outros clientes). Resposta: { v: centavos, d: '13/out' | null, nome }. */
  function rates(zip, uf) {
    var q = 'shipping_address[zip]=' + encodeURIComponent(zip) + '&shipping_address[country]=BR&shipping_address[province]=' + uf;
    return fetch(root + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST' })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        var tries = 0;
        return (function poll() {
          return fetch(root + 'cart/async_shipping_rates.json?' + q).then(function (r2) { return r2.json(); }).then(function (j) {
            if (j && j.shipping_rates) return j.shipping_rates;
            if (++tries > 12) throw new Error('timeout');
            return new Promise(function (res) { setTimeout(res, 500); }).then(poll);
          });
        })();
      });
  }
  function melhor(list) {
    if (!list || !list.length) return null;
    list.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
    var r0 = list[0], d = null;
    var days = r0.delivery_days && r0.delivery_days.length ? Math.max.apply(null, r0.delivery_days) : null;
    if (r0.delivery_date || days != null) {
      var dt = r0.delivery_date ? new Date(r0.delivery_date + 'T12:00:00') : new Date(Date.now() + days * 864e5);
      d = dt.getDate() + '/' + MES[dt.getMonth()];
    }
    return { v: Math.round(parseFloat(r0.price) * 100), d: d, nome: r0.name || 'Entrega' };
  }
  var fila = Promise.resolve();
  function cotar(cep, variante, qtd) {
    var dig = String(cep).replace(/\D/g, '');
    var zip = dig.slice(0, 5) + '-' + dig.slice(5);
    var uf = ufOf(+dig.slice(0, 5));
    if (dig.length !== 8 || !uf) return Promise.reject({ msg: 'Confira o CEP.' });
    var tarefa = function () {
      if (!variante) return rates(zip, uf).then(melhor);
      var chave = null;
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variante), quantity: qtd || 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw { msg: j.description || 'Não deu para calcular agora.' }; return j; }); })
        .then(function (j) { chave = j.items && j.items[0] ? j.items[0].key : null; return { q: j.items && j.items[0] ? j.items[0].quantity : 0 }; })
        .then(function (linha) {
          var volta = function () {
            if (!chave) return Promise.resolve();
            return fetch(root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: chave, quantity: Math.max(0, linha.q - (qtd || 1)) })
            });
          };
          return rates(zip, uf).then(function (list) {
            return volta().then(function () { return melhor(list); });
          }, function (err) {
            return volta().then(function () { throw err; });
          });
        });
    };
    var p = fila.then(tarefa, tarefa);
    fila = p.catch(function () {});
    return p;
  }
  window.PlentyFrete = { cotar: cotar };

  function shipCalc(cep) {
    var zip = cep.slice(0, 5) + '-' + cep.slice(5);
    S.fr = { open: true, cep: zip, busy: true };
    draw();
    cotar(cep)
      .then(function (m) {
        if (!m) { S.fr = { open: true, cep: zip, err: 'Não encontramos entrega para este CEP.' }; draw(); return; }
        S.fr = { cep: zip, v: m.v, res: m.d ? 'Chega até <b>' + m.d + '</b>' : esc(m.nome) };
        draw();
      })
      .catch(function (e) {
        S.fr = { open: true, cep: zip, err: (e && e.msg) || 'Não deu para calcular agora. Confira o CEP e tente de novo.' };
        draw();
      });
  }

  /* ---------- movimento ---------- */
  function fxo(els, cb) {
    els = [].slice.call(els);
    if (!els.length || reduce.matches) { cb(); return; }
    els.forEach(function (el) {
      if (el.tagName === 'LI') el.style.setProperty('--h', el.offsetHeight + 'px');
      el.classList.add('ps-fxo');
    });
    setTimeout(cb, 170);
  }

  /* ---------- eventos ---------- */
  function onClick(e) {
    var t = e.target;
    var b = t.closest('[data-a]');
    if (!b || !box.contains(b)) return;
    /* o redesenho tira o botão da página; sem isto a gaveta do tema acha que o clique foi fora e fecha */
    e.stopPropagation();
    var a = b.dataset.a, i = +b.dataset.i;
    if (a === 'close') {
      var cd = box.closest('cart-drawer-component');
      if (cd && typeof cd.close === 'function') cd.close();
      return;
    }
    if (a === 'inc') { change(D.items[i].key, D.items[i].q + 1); return; }
    if (a === 'dec') {
      var it = D.items[i];
      if (it.q === 1) { fxo([b.closest('li')], function () { change(it.key, 0); }); return; }
      change(it.key, it.q - 1);
      return;
    }
    if (a === 'cpop') { S.open = true; S.err = ''; draw(); var inp = box.querySelector('[data-cp]'); if (inp) inp.focus(); return; }
    if (a === 'cpap') {
      var v = (box.querySelector('[data-cp]').value || '').trim().toUpperCase();
      S.input = v;
      if (!v) { S.err = 'Digite o código.'; draw(); return; }
      applyCode(v);
      return;
    }
    if (a === 'cprm') { removeCode(); return; }
    if (a === 'frop') { S.fr = { open: true, cep: S.fr.cep || '' }; draw(); var ci = box.querySelector('[data-cep]'); if (ci) ci.focus(); return; }
    if (a === 'frc') {
      var d = (box.querySelector('[data-cep]').value || '').replace(/\D/g, '');
      if (d.length !== 8) { S.fr = { open: true, cep: box.querySelector('[data-cep]').value, err: 'Digite os 8 números do CEP.' }; draw(); var c2 = box.querySelector('[data-cep]'); if (c2) { c2.focus(); c2.setSelectionRange(c2.value.length, c2.value.length); } return; }
      shipCalc(d);
      return;
    }
    if (a === 'pick') {
      var ci = +b.dataset.i, card = b.closest('.ps-ofr-c');
      S.pk = { i: ci, pid: +b.dataset.pid };
      S.pkFx = true;
      S.railIdx = ci;
      fxo(card.querySelectorAll('.ps-ofr-t, .ps-ofr-add'), draw);
      return;
    }
    if (a === 'pcol') { S.pk.pid = +b.dataset.pid; draw(); return; }
    if (a === 'pcx' || a === 'psz') {
      var id = b.dataset.id;
      fxo(box.querySelectorAll('.ps-ofr-pk'), function () {
        S.ofrFxI = S.pk ? S.pk.i : -1;
        S.pk = null;
        S.ofrFx = true;
        if (id) addVariant(id);
        else draw();
      });
    }
  }
  function onInput(e) {
    if (e.target.matches('[data-cep]')) {
      var d = e.target.value.replace(/\D/g, '').slice(0, 8);
      e.target.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
      S.fr.cep = e.target.value;
      var er = box.querySelector('.ps-cepo + .ps-err');
      if (er && !er.classList.contains('ps-fxo')) { er.classList.add('ps-fxo'); S.fr.err = ''; setTimeout(function () { er.remove(); }, 170); }
    }
    if (e.target.matches('[data-cp]')) S.input = e.target.value;
  }
  function onKey(e) {
    if (e.target.matches('[data-cep]')) {
      if (e.key === 'Enter') { e.preventDefault(); box.querySelector('[data-a="frc"]').click(); }
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); S.fr = { cep: S.fr.cep }; draw(); }
    }
    if (e.target.matches('[data-cp]')) {
      if (e.key === 'Enter') { e.preventDefault(); box.querySelector('[data-a="cpap"]').click(); }
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); S.open = false; S.err = ''; draw(); }
    }
  }

  function init() {
    var el = document.querySelector('[data-psc]');
    if (!el) return;
    box = el.querySelector('[data-psc-box]');
    var s = el.querySelector('[data-ps-data]');
    try { D = JSON.parse(s.textContent); } catch (err) { D = null; }
    S.seen = null;
    draw();
    S.seen = {};
    D && D.items.forEach(function (it) { S.seen[it.key] = 1; });
    var dlg = el.closest('dialog');
    if (dlg) {
      new MutationObserver(function () {
        if (!dlg.open) return;
        /* ao abrir, a fileira volta para a primeira peça e espera um pouco antes de passar */
        S.railIdx = 0;
        T.hold = Date.now() + 3500;
        var r0 = railEl();
        if (r0 && !S.pk) { r0.scrollLeft = 0; railOff(r0, 0); }
        box.classList.add('ps-opening');
        clearTimeout(box.__op);
        box.__op = setTimeout(function () { box.classList.remove('ps-opening'); }, 700);
      }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    }
    setInterval(railTick, 3500);
    box.addEventListener('click', onClick);
    box.addEventListener('input', onInput);
    box.addEventListener('keydown', onKey);
    /* outra parte do site mexeu na sacola (card, página de produto): busca os dados de novo */
    document.addEventListener('cart:update', function (e) {
      var src = e.detail && (e.detail.sourceId || (e.detail.data && e.detail.data.source));
      if (src === 'psc') return;
      refresh();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
